import { FC } from 'react';

import { Card, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import useIsExternalVacancy from 'utils/campaign/hooks/useIsExternalVacancy';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { ProfRoleSelector } from 'components/CpcFlexibleCreate/PredictWindow/ProfRoleSelector/ProfRoleSelector';
import { TrafficLight } from 'components/CpcFlexibleCreate/PredictWindow/TrafficLight/TrafficLight';
import { useDownloadPredictData } from 'components/CpcFlexibleCreate/PredictWindow/utils/useDownloadPredictData';

import {
    PredictWindowMode,
    selectIsReadyPredictWindow,
    selectPredictWindowMode,
    selectProfRolesReachCategory,
} from 'store/models/predictWindow';
import { useSelector } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.PredictWindow.titleMagritte',
};

const PredictWindowComponent: FC = () => {
    const isReady = useSelector(selectIsReadyPredictWindow);
    const mode = useSelector(selectPredictWindowMode);
    const status = useSelector(selectProfRolesReachCategory);
    const isExternalVacancy = useIsExternalVacancy();

    const trl = useTrls();

    useDownloadPredictData();

    if (!isReady || isExternalVacancy) return null;

    return (
        <div>
            <Card padding={24} borderRadius={24} borderWidth="default" stretched data-qa="sidebar__predict-window-card">
                <Text typography="title-5-semibold" data-qa="sidebar__predict-window-title">
                    {trl(TrlKeys.title)}
                </Text>
                {status && (
                    <>
                        <VSpacing default={8} />
                        <TrafficLight status={status} />
                    </>
                )}
                {mode === PredictWindowMode.WithSelector && (
                    <>
                        <VSpacing default={24} />
                        <ProfRoleSelector />
                    </>
                )}
            </Card>
            <VSpacing default={32} />
        </div>
    );
};

const PredictWindow = withErrorBoundary(PredictWindowComponent);
export { PredictWindow };
